(() => {
  const YEAR_PATTERN = /^\d{4}$/;

  const initPurchasedFramesForm = (form) => {
    if (!form || form.dataset.purchasedFramesFormInitialized === 'true') return;

    form.dataset.purchasedFramesFormInitialized = 'true';

    const status = form.querySelector('[data-purchased-frames-form-status]');
    const emailInput = form.querySelector('input[name="inp_3"]');
    const yearInput = form.querySelector('[data-purchased-frames-form-year]');
    const frame = form.target ? document.getElementsByName(form.target)[0] : null;

    const applyQueryParams = () => {
      const params = new URLSearchParams(window.location.search);

      form.querySelectorAll('[data-query-param]').forEach((input) => {
        const value = params.get(input.getAttribute('data-query-param'));

        if (value !== null) {
          input.value = value;
        }
      });
    };

    applyQueryParams();

    const clearStatus = () => {
      form.querySelectorAll('[aria-invalid="true"]').forEach((field) => {
        field.removeAttribute('aria-invalid');
      });

      if (status) {
        status.textContent = '';
        status.hidden = true;
        status.classList.remove('purchased-frames-form__status--success');
      }
    };

    const showError = (message, field) => {
      if (status) {
        status.textContent = message;
        status.hidden = false;
        status.classList.remove('purchased-frames-form__status--success');
      }

      if (field) {
        field.setAttribute('aria-invalid', 'true');
        field.focus();
      }
    };

    const showSuccess = (message) => {
      if (!status) return;

      status.textContent = message;
      status.hidden = false;
      status.classList.add('purchased-frames-form__status--success');
    };

    let awaitingResponse = false;
    let fallbackTimer = null;

    const completeSubmission = () => {
      if (!awaitingResponse) return;

      awaitingResponse = false;
      clearTimeout(fallbackTimer);

      form.reset();
      applyQueryParams();
      showSuccess(form.dataset.successMessage || 'Your registration has been submitted successfully');
    };

    frame?.addEventListener('load', completeSubmission);

    form.addEventListener('submit', (event) => {
      clearStatus();

      const email = emailInput ? emailInput.value.trim() : '';

      if (emailInput && (email === '' || !emailInput.checkValidity())) {
        event.preventDefault();
        showError(form.dataset.errorEmail || 'Enter a valid email address', emailInput);
        return;
      }

      const year = yearInput ? yearInput.value.trim() : '';

      if (year !== '' && !YEAR_PATTERN.test(year)) {
        event.preventDefault();
        showError(form.dataset.errorYear || 'Enter the year with 4 digits', yearInput);
        return;
      }

      awaitingResponse = true;
      clearTimeout(fallbackTimer);
      fallbackTimer = setTimeout(completeSubmission, 600);
    });

    form.addEventListener('input', () => {
      if (awaitingResponse) return;

      clearStatus();
    });
  };

  const initAllPurchasedFramesForms = () => {
    document
      .querySelectorAll('[data-purchased-frames-form]')
      .forEach(initPurchasedFramesForm);
  };

  document.addEventListener('DOMContentLoaded', initAllPurchasedFramesForms);

  document.addEventListener('shopify:section:load', (event) => {
    const form = event.target.querySelector('[data-purchased-frames-form]');

    if (form) {
      initPurchasedFramesForm(form);
    }
  });
})();
